import { IconButton } from "@mui/material";
import { alpha } from "@mui/material/styles";

const AppIconButton = ({ sx, ...props }) => (
  <IconButton
    size="small"
    sx={[
      (theme) => ({
        color: theme.palette.text.secondary,
        borderRadius: 1,
        "&:hover": {
          backgroundColor: alpha(theme.palette.text.secondary, 0.12),
        },
      }),
      sx,
    ]}
    {...props}
  />
);

export default AppIconButton;
